import { apiClient } from '../utils/axios';

export const printPdf = async (documentType, documentId, template, is_receipt) => {
  const response = await apiClient.get(`/${documentType.toLowerCase()}/${documentId}/download-pdf`, {
    params: { template_name: template.name, is_receipt },
    responseType: 'blob',
  });
  const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const printWindow = window.open(pdfUrl, '_blank');
  printWindow.onload = () => {
    printWindow.print();
  };
};
